import React from "react";
import Container from "../layout/Container";

const Details = () => {
  return (
    <Container>
      <div className="mt-2 h-[503px] w-[770px] rounded border border-solid border-darkGreen border-opacity-30">
        <div className="py-4 px-4">
          <div className="h-[223px] w-[645px] border-b border-solid border-darkGreen border-opacity-20">
            <h5 className="mb-2 font-pop text-xl font-bold text-primary">
              Details
            </h5>
            <div className="flex">
              <div className="w-[25%]">
                <ul className="font-regular flex flex-col gap-y-2 font-pop text-sm text-darkGreen text-opacity-60">
                  <li>Make</li>
                  <li>Body Style</li>
                  <li>Year</li>
                  <li>Door</li>
                  <li>Seller Type</li>
                  <li>Color</li>
                </ul>
              </div>
              <div className="w-[25%]">
                <ul className=" font-regular flex flex-col gap-y-2 font-pop text-sm text-darkGreen">
                  <li>BMW</li>
                  <li>Sedan</li>
                  <li>2017</li>
                  <li>4</li>
                  <li>Dealer</li>
                  <li>Silver</li>
                </ul>
              </div>
              <div className="w-[25%]">
                <ul className=" font-regular flex flex-col gap-y-2 font-pop text-sm text-darkGreen text-opacity-60">
                  <li>Model</li>
                  <li>Mileage</li>
                  <li>Fuel</li>
                  <li>Condition</li>
                  <li>Transmission</li>
                </ul>
              </div>
              <div className="w-[25%]">
                <ul className=" font-regular flex flex-col gap-y-2 font-pop text-sm text-[#002F34]">
                  <li>M3</li>
                  <li>600000 KM</li>
                  <li>Petrol</li>
                  <li>Used</li>
                  <li>Automatic</li>
                </ul>
              </div>
            </div>
          </div>
          <div>
            <h5 className="mt-4 font-pop text-xl font-bold text-primary">
              Description
            </h5>
            <div className="h-[150px] w-[410px]">
              <p className="font-regular mb-2 font-pop text-sm leading-6 text-darkGreen">
                Immaculate interior condition.Full service history with bmw.
                Minor dents and sratches on exterior.New windscreen.Tyres
                Digital instrument cluster.Heated front seats.Reverse camera.
                Detachable tow bar.Sunroof.M sport model. 330D very economical
                and powerful 190kw still in good condition
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Details;
